import api from 'services/api';

const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getDefaultDateRange = () => ({
  data_inicio: formatLocalDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
  data_fim: formatLocalDate(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0))
});

const getTodayLocalDate = () => formatLocalDate(new Date());

class ContratosConsolidadoService {
  normalizarNumero(valor) {
    if (valor === null || valor === undefined || valor === '') {
      return 0;
    }

    if (typeof valor === 'string' && valor.includes(',')) {
      return Number(valor.replace(/\./g, '').replace(',', '.')) || 0;
    }

    return Number(valor) || 0;
  }

  parseIntComAlias(obj, aliases) {
    for (const alias of aliases) {
      const valor = obj?.[alias];
      if (valor !== undefined && valor !== null && valor !== '') {
        return parseInt(valor, 10) || 0;
      }
    }

    return 0;
  }

  parseValorComAlias(obj, aliases) {
    for (const alias of aliases) {
      const valor = obj?.[alias];
      if (valor !== undefined && valor !== null && valor !== '') {
        return valor;
      }
    }

    return 0;
  }

  normalizarChavePlano(plano = {}) {
    if (plano.idPlano !== null && plano.idPlano !== undefined && plano.idPlano !== '') {
      return `id:${String(plano.idPlano)}`;
    }

    const nomeNormalizado = String(plano.nome || '')
      .trim()
      .toLowerCase();

    return `nome:${nomeNormalizado || 'plano-nao-informado'}`;
  }

  normalizarChaveCidade(cidade = {}) {
    const nomeNormalizado = String(cidade.cidadeNome || cidade.cidade_nome || cidade.nome || '')
      .trim()
      .toLowerCase();

    if (nomeNormalizado) {
      return `nome:${nomeNormalizado}`;
    }

    if (cidade.idCidade !== null && cidade.idCidade !== undefined && cidade.idCidade !== '') {
      return `id:${String(cidade.idCidade)}`;
    }

    return 'nome:cidade-nao-informada';
  }

  adaptarPlano(planoApi) {
    const plano = planoApi || {};
    const contratosBloqueioManual = this.parseIntComAlias(plano, ['contratos_bloqueio_manual', 'contratosBloqueioManual']);
    const valorBloqueioManual = this.normalizarNumero(
      this.parseValorComAlias(plano, ['valor_bloqueio_manual', 'valorBloqueioManual'])
    );
    const contratosEmitidos = this.parseIntComAlias(plano, ['contratos_emitidos', 'contratosEmitidos']);
    const titulosEmitidos = this.parseIntComAlias(plano, ['titulos_emitidos', 'titulosEmitidos']);
    const valorEmitido = this.normalizarNumero(this.parseValorComAlias(plano, ['valor_emitido', 'valorEmitido']));
    const valorAteVencimento = this.normalizarNumero(this.parseValorComAlias(plano, ['valor_ate_vencimento', 'valorAteVencimento']));
    const descontoTotal = this.normalizarNumero(this.parseValorComAlias(plano, ['desconto_total', 'descontoTotal']));
    const contratosRecebidos = this.parseIntComAlias(plano, ['contratos_recebidos', 'contratosRecebidos']);
    const titulosRecebidos = this.parseIntComAlias(plano, ['titulos_recebidos', 'titulosRecebidos']);
    const valorRecebido = this.normalizarNumero(this.parseValorComAlias(plano, ['valor_recebido', 'valorRecebido']));
    const contratosEmitidosPf = this.parseIntComAlias(plano, ['contratos_emitidos_pf', 'contratosEmitidosPf']);
    const titulosEmitidosPf = this.parseIntComAlias(plano, ['titulos_emitidos_pf', 'titulosEmitidosPf']);
    const valorEmitidoPf = this.normalizarNumero(this.parseValorComAlias(plano, ['valor_emitido_pf', 'valorEmitidoPf']));
    const contratosRecebidosPf = this.parseIntComAlias(plano, ['contratos_recebidos_pf', 'contratosRecebidosPf']);
    const titulosRecebidosPf = this.parseIntComAlias(plano, ['titulos_recebidos_pf', 'titulosRecebidosPf']);
    const valorRecebidoPf = this.normalizarNumero(this.parseValorComAlias(plano, ['valor_recebido_pf', 'valorRecebidoPf']));
    const contratosEmitidosPj = this.parseIntComAlias(plano, ['contratos_emitidos_pj', 'contratosEmitidosPj']);
    const titulosEmitidosPj = this.parseIntComAlias(plano, ['titulos_emitidos_pj', 'titulosEmitidosPj']);
    const valorEmitidoPj = this.normalizarNumero(this.parseValorComAlias(plano, ['valor_emitido_pj', 'valorEmitidoPj']));
    const contratosRecebidosPj = this.parseIntComAlias(plano, ['contratos_recebidos_pj', 'contratosRecebidosPj']);
    const titulosRecebidosPj = this.parseIntComAlias(plano, ['titulos_recebidos_pj', 'titulosRecebidosPj']);
    const valorRecebidoPj = this.normalizarNumero(this.parseValorComAlias(plano, ['valor_recebido_pj', 'valorRecebidoPj']));

    return {
      idPlano: plano.id_plano ?? plano.idPlano ?? plano.id ?? null,
      nome: plano.vd_contratos_nome ?? plano.nome ?? plano.plano ?? 'Plano não informado',
      totalContratos: parseInt(plano.total_contratos ?? plano.totalContratos ?? 0, 10) || 0,
      contratosPf: parseInt(plano.contratos_pf ?? plano.contratosPf ?? 0, 10) || 0,
      contratosPj: parseInt(plano.contratos_pj ?? plano.contratosPj ?? 0, 10) || 0,
      faturamentoPf: this.normalizarNumero(plano.faturamento_pf ?? plano.faturamentoPf),
      faturamentoPj: this.normalizarNumero(plano.faturamento_pj ?? plano.faturamentoPj),
      faturamentoTotal: this.normalizarNumero(
        plano.faturamento_total ??
        plano.faturamentoTotal ??
        (this.normalizarNumero(plano.faturamento_pf ?? plano.faturamentoPf) + this.normalizarNumero(plano.faturamento_pj ?? plano.faturamentoPj))
      ),
      ativos: parseInt(plano.ativos ?? 0, 10) || 0,
      suspensos: parseInt(plano.suspensos ?? 0, 10) || 0,
      internetOk: parseInt(plano.internetOk ?? plano.internet_ok ?? 0, 10) || 0,
      internetProblema: parseInt(plano.internetProblema ?? plano.internet_problema ?? 0, 10) || 0,
      contratosBloqueioManual,
      valorBloqueioManual,
      contratosEmitidos,
      titulosEmitidos,
      valorEmitido,
      valorAteVencimento,
      descontoTotal,
      contratosRecebidos,
      titulosRecebidos,
      valorRecebido,
      contratosEmitidosPf,
      titulosEmitidosPf,
      valorEmitidoPf,
      contratosRecebidosPf,
      titulosRecebidosPf,
      valorRecebidoPf,
      contratosEmitidosPj,
      titulosEmitidosPj,
      valorEmitidoPj,
      contratosRecebidosPj,
      titulosRecebidosPj,
      valorRecebidoPj,
      contratos_bloqueio_manual: contratosBloqueioManual,
      valor_bloqueio_manual: valorBloqueioManual,
      contratos_emitidos: contratosEmitidos,
      titulos_emitidos: titulosEmitidos,
      valor_emitido: valorEmitido,
      valor_ate_vencimento: valorAteVencimento,
      desconto_total: descontoTotal,
      contratos_recebidos: contratosRecebidos,
      titulos_recebidos: titulosRecebidos,
      valor_recebido: valorRecebido,
      contratos_emitidos_pf: contratosEmitidosPf,
      titulos_emitidos_pf: titulosEmitidosPf,
      valor_emitido_pf: valorEmitidoPf,
      contratos_recebidos_pf: contratosRecebidosPf,
      titulos_recebidos_pf: titulosRecebidosPf,
      valor_recebido_pf: valorRecebidoPf,
      contratos_emitidos_pj: contratosEmitidosPj,
      titulos_emitidos_pj: titulosEmitidosPj,
      valor_emitido_pj: valorEmitidoPj,
      contratos_recebidos_pj: contratosRecebidosPj,
      titulos_recebidos_pj: titulosRecebidosPj,
      valor_recebido_pj: valorRecebidoPj
    };
  }

  adaptarCidade(cidadeApi) {
    const cidade = cidadeApi || {};
    const planos = Array.isArray(cidade.planos)
      ? cidade.planos.map((plano) => this.adaptarPlano(plano))
      : [];

    return {
      idCidade: cidade.idCidade ?? cidade.id_cidade ?? null,
      cidadeNome: cidade.cidadeNome ?? cidade.cidade_nome ?? cidade.nome ?? 'Cidade não informada',
      totalContratos: parseInt(cidade.totalContratos ?? cidade.total_contratos ?? 0, 10) || 0,
      valorTotal: this.normalizarNumero(cidade.valorTotal ?? cidade.valor_total),
      ativos: parseInt(cidade.ativos ?? 0, 10) || 0,
      suspensos: parseInt(cidade.suspensos ?? 0, 10) || 0,
      pessoasFisicas: parseInt(cidade.pessoasFisicas ?? cidade.pessoas_fisicas ?? 0, 10) || 0,
      pessoasJuridicas: parseInt(cidade.pessoasJuridicas ?? cidade.pessoas_juridicas ?? 0, 10) || 0,
      faturamentoPessoaFisica: this.normalizarNumero(
        cidade.faturamentoPessoaFisica ?? cidade.faturamento_pessoa_fisica
      ),
      faturamentoPessoaJuridica: this.normalizarNumero(
        cidade.faturamentoPessoaJuridica ?? cidade.faturamento_pessoa_juridica
      ),
      contratosBloqueioManual: parseInt(cidade.contratosBloqueioManual ?? cidade.contratos_bloqueio_manual ?? 0, 10) || 0,
      valorBloqueioManual: this.normalizarNumero(cidade.valorBloqueioManual ?? cidade.valor_bloqueio_manual),
      titulosEmitidos: this.parseIntComAlias(cidade, ['titulos_emitidos', 'titulosEmitidos']),
      contratosEmitidos: this.parseIntComAlias(cidade, ['contratos_emitidos', 'contratosEmitidos']),
      valorEmitido: this.normalizarNumero(cidade.valorEmitido ?? cidade.valor_emitido),
      valorAteVencimento: this.normalizarNumero(cidade.valorAteVencimento ?? cidade.valor_ate_vencimento),
      descontoTotal: this.normalizarNumero(cidade.descontoTotal ?? cidade.desconto_total),
      titulosRecebidos: this.parseIntComAlias(cidade, ['titulos_recebidos', 'titulosRecebidos']),
      contratosRecebidos: this.parseIntComAlias(cidade, ['contratos_recebidos', 'contratosRecebidos']),
      valorRecebido: this.normalizarNumero(cidade.valorRecebido ?? cidade.valor_recebido),
      titulosEmitidosPf: this.parseIntComAlias(cidade, ['titulos_emitidos_pf', 'titulosEmitidosPf']),
      contratosEmitidosPf: this.parseIntComAlias(cidade, ['contratos_emitidos_pf', 'contratosEmitidosPf']),
      valorEmitidoPf: this.normalizarNumero(cidade.valorEmitidoPf ?? cidade.valor_emitido_pf),
      titulosRecebidosPf: this.parseIntComAlias(cidade, ['titulos_recebidos_pf', 'titulosRecebidosPf']),
      contratosRecebidosPf: this.parseIntComAlias(cidade, ['contratos_recebidos_pf', 'contratosRecebidosPf']),
      valorRecebidoPf: this.normalizarNumero(cidade.valorRecebidoPf ?? cidade.valor_recebido_pf),
      titulosEmitidosPj: this.parseIntComAlias(cidade, ['titulos_emitidos_pj', 'titulosEmitidosPj']),
      contratosEmitidosPj: this.parseIntComAlias(cidade, ['contratos_emitidos_pj', 'contratosEmitidosPj']),
      valorEmitidoPj: this.normalizarNumero(cidade.valorEmitidoPj ?? cidade.valor_emitido_pj),
      titulosRecebidosPj: this.parseIntComAlias(cidade, ['titulos_recebidos_pj', 'titulosRecebidosPj']),
      contratosRecebidosPj: this.parseIntComAlias(cidade, ['contratos_recebidos_pj', 'contratosRecebidosPj']),
      valorRecebidoPj: this.normalizarNumero(cidade.valorRecebidoPj ?? cidade.valor_recebido_pj),
      planos
    };
  }

  consolidarPlanos(consolidado, planos, empresa) {
    if (!Array.isArray(planos)) {
      return;
    }

    planos.forEach((planoApi) => {
      const plano = this.adaptarPlano(planoApi);
      const chave = `${plano.idPlano ?? ''}::${plano.nome}`.toLowerCase();
      const planoExistente = consolidado.find((item) => `${item.idPlano ?? ''}::${item.nome}`.toLowerCase() === chave);

      if (planoExistente) {
        planoExistente.totalContratos += plano.totalContratos;
        planoExistente.contratosPf += plano.contratosPf;
        planoExistente.contratosPj += plano.contratosPj;
        planoExistente.faturamentoPf += plano.faturamentoPf;
        planoExistente.faturamentoPj += plano.faturamentoPj;
        planoExistente.faturamentoTotal += plano.faturamentoTotal;
        planoExistente.ativos += plano.ativos;
        planoExistente.suspensos += plano.suspensos;
        planoExistente.internetOk += plano.internetOk;
        planoExistente.internetProblema += plano.internetProblema;
        planoExistente.contratosBloqueioManual += plano.contratosBloqueioManual;
        planoExistente.valorBloqueioManual += plano.valorBloqueioManual;
        planoExistente.titulosEmitidos += plano.titulosEmitidos;
        planoExistente.contratosEmitidos += plano.contratosEmitidos;
        planoExistente.valorEmitido += plano.valorEmitido;
        planoExistente.valorAteVencimento += plano.valorAteVencimento;
        planoExistente.descontoTotal += plano.descontoTotal;
        planoExistente.titulosRecebidos += plano.titulosRecebidos;
        planoExistente.contratosRecebidos += plano.contratosRecebidos;
        planoExistente.valorRecebido += plano.valorRecebido;
        planoExistente.titulosEmitidosPf += plano.titulosEmitidosPf;
        planoExistente.contratosEmitidosPf += plano.contratosEmitidosPf;
        planoExistente.valorEmitidoPf += plano.valorEmitidoPf;
        planoExistente.titulosRecebidosPf += plano.titulosRecebidosPf;
        planoExistente.contratosRecebidosPf += plano.contratosRecebidosPf;
        planoExistente.valorRecebidoPf += plano.valorRecebidoPf;
        planoExistente.titulosEmitidosPj += plano.titulosEmitidosPj;
        planoExistente.contratosEmitidosPj += plano.contratosEmitidosPj;
        planoExistente.valorEmitidoPj += plano.valorEmitidoPj;
        planoExistente.titulosRecebidosPj += plano.titulosRecebidosPj;
        planoExistente.contratosRecebidosPj += plano.contratosRecebidosPj;
        planoExistente.valorRecebidoPj += plano.valorRecebidoPj;
        planoExistente.contratos_emitidos += plano.contratos_emitidos;
        planoExistente.titulos_emitidos += plano.titulos_emitidos;
        planoExistente.valor_emitido += plano.valor_emitido;
        planoExistente.contratos_recebidos += plano.contratos_recebidos;
        planoExistente.titulos_recebidos += plano.titulos_recebidos;
        planoExistente.valor_recebido += plano.valor_recebido;
        planoExistente.contratos_emitidos_pf += plano.contratos_emitidos_pf;
        planoExistente.titulos_emitidos_pf += plano.titulos_emitidos_pf;
        planoExistente.valor_emitido_pf += plano.valor_emitido_pf;
        planoExistente.contratos_recebidos_pf += plano.contratos_recebidos_pf;
        planoExistente.titulos_recebidos_pf += plano.titulos_recebidos_pf;
        planoExistente.valor_recebido_pf += plano.valor_recebido_pf;
        planoExistente.contratos_emitidos_pj += plano.contratos_emitidos_pj;
        planoExistente.titulos_emitidos_pj += plano.titulos_emitidos_pj;
        planoExistente.valor_emitido_pj += plano.valor_emitido_pj;
        planoExistente.contratos_recebidos_pj += plano.contratos_recebidos_pj;
        planoExistente.titulos_recebidos_pj += plano.titulos_recebidos_pj;
        planoExistente.valor_recebido_pj += plano.valor_recebido_pj;
        if (!Array.isArray(planoExistente.empresas)) {
          planoExistente.empresas = [];
        }
        if (!planoExistente.empresas.includes(empresa)) {
          planoExistente.empresas.push(empresa);
        }
      } else {
        consolidado.push({
          ...plano,
          empresas: empresa ? [empresa] : []
        });
      }
    });
  }

  /**
   * Adapta os dados da API para o formato esperado pelo frontend
   */
  adaptarContrato(contratoApi) {
    // Mapeamento de tipos de pessoa do N8N para o frontend
    const mapeamentoTipoPessoa = {
      'F': 'Física',
      'J': 'Jurídica', 
      'E': 'Estrangeiro'
    };

    return {
      id: contratoApi.contrato_id || 'N/A',
      cliente: contratoApi.razao || contratoApi.cliente || 'Cliente não informado',
      cnpj_cpf: contratoApi.cnpj_cpf || 'CPF/CNPJ não informado',
      cidade: contratoApi.cidade || 'Cidade não informada',
      email: contratoApi.cliente_email || 'Email não informado',
      plano: contratoApi.contrato_plano || 'Plano não informado',
      valor_contrato: parseFloat(contratoApi.valor_contrato || contratoApi.valor_plano || 0),
      data_ativacao: contratoApi.data_ativacao || 'Data não informada',
      celular: contratoApi.celular || 'Celular não informado',
      tipo_pessoa: mapeamentoTipoPessoa[contratoApi.tipo_pessoa] || contratoApi.tipo_pessoa || 'Tipo não informado',
      status_cliente: contratoApi.status_cliente || 'N',
      data_assinatura: contratoApi.data_assinatura || null,
      data_renovacao: contratoApi.data_renovacao || null,
      status_contrato: contratoApi.status_contrato || contratoApi.contrato_status || 'I',
      status_internet: contratoApi.status_internet || 'SS'
    };
  }

  /**
   * Adapta o resumo da API para o formato esperado pelo frontend
  */
  adaptarResumo(resumoApi) {
    const resumo = Array.isArray(resumoApi) ? (resumoApi[0] || {}) : (resumoApi || {});
    const cidades = Array.isArray(resumo.cidades)
      ? resumo.cidades.map((cidade) => this.adaptarCidade(cidade))
      : [];
    const faturamentoCpf = this.normalizarNumero(
      resumo.faturamentoCpf ??
      resumo.faturamento_cpf ??
      resumo.faturamentoPessoaFisica ??
      resumo.faturamento_pessoa_fisica ??
      0
    );
    const faturamentoCnpj = this.normalizarNumero(
      resumo.faturamentoCnpj ??
      resumo.faturamento_cnpj ??
      resumo.faturamentoPessoaJuridica ??
      resumo.faturamento_pessoa_juridica ??
      0
    );
    const contratosBloqueioManual = parseInt(resumo.contratosBloqueioManual ?? resumo.contratos_bloqueio_manual ?? 0, 10) || 0;
    const valorBloqueioManual = this.normalizarNumero(resumo.valorBloqueioManual ?? resumo.valor_bloqueio_manual);
    const titulosEmitidos = this.parseIntComAlias(resumo, ['titulos_emitidos', 'titulosEmitidos']);
    const contratosEmitidos = this.parseIntComAlias(resumo, ['contratos_emitidos', 'contratosEmitidos']);
    const valorEmitido = this.normalizarNumero(this.parseValorComAlias(resumo, ['valor_emitido', 'valorEmitido']));
    const valorAteVencimento = this.normalizarNumero(this.parseValorComAlias(resumo, ['valor_ate_vencimento', 'valorAteVencimento']));
    const descontoTotal = this.normalizarNumero(this.parseValorComAlias(resumo, ['desconto_total', 'descontoTotal']));
    const titulosRecebidos = this.parseIntComAlias(resumo, ['titulos_recebidos', 'titulosRecebidos']);
    const contratosRecebidos = this.parseIntComAlias(resumo, ['contratos_recebidos', 'contratosRecebidos']);
    const valorRecebido = this.normalizarNumero(this.parseValorComAlias(resumo, ['valor_recebido', 'valorRecebido']));
    const titulosEmitidosPf = this.parseIntComAlias(resumo, ['titulos_emitidos_pf', 'titulosEmitidosPf']);
    const contratosEmitidosPf = this.parseIntComAlias(resumo, ['contratos_emitidos_pf', 'contratosEmitidosPf']);
    const valorEmitidoPf = this.normalizarNumero(this.parseValorComAlias(resumo, ['valor_emitido_pf', 'valorEmitidoPf']));
    const titulosRecebidosPf = this.parseIntComAlias(resumo, ['titulos_recebidos_pf', 'titulosRecebidosPf']);
    const contratosRecebidosPf = this.parseIntComAlias(resumo, ['contratos_recebidos_pf', 'contratosRecebidosPf']);
    const valorRecebidoPf = this.normalizarNumero(this.parseValorComAlias(resumo, ['valor_recebido_pf', 'valorRecebidoPf']));
    const titulosEmitidosPj = this.parseIntComAlias(resumo, ['titulos_emitidos_pj', 'titulosEmitidosPj']);
    const contratosEmitidosPj = this.parseIntComAlias(resumo, ['contratos_emitidos_pj', 'contratosEmitidosPj']);
    const valorEmitidoPj = this.normalizarNumero(this.parseValorComAlias(resumo, ['valor_emitido_pj', 'valorEmitidoPj']));
    const titulosRecebidosPj = this.parseIntComAlias(resumo, ['titulos_recebidos_pj', 'titulosRecebidosPj']);
    const contratosRecebidosPj = this.parseIntComAlias(resumo, ['contratos_recebidos_pj', 'contratosRecebidosPj']);
    const valorRecebidoPj = this.normalizarNumero(this.parseValorComAlias(resumo, ['valor_recebido_pj', 'valorRecebidoPj']));
    const valorTotal = this.normalizarNumero(resumo.valorTotal ?? resumo.valor_total ?? (faturamentoCpf + faturamentoCnpj));

    return {
      totalContratos: parseInt(resumo.totalContratos ?? resumo.total_contratos) || 0,
      valorTotal,
      faturamentoCpf,
      faturamentoCnpj,
      faturamentoPessoaFisica: faturamentoCpf,
      faturamentoPessoaJuridica: faturamentoCnpj,
      ativos: parseInt(resumo.ativos) || 0,
      suspensos: parseInt(resumo.suspensos) || 0,
      internetOk: parseInt(resumo.internetOk) || 0,
      internetProblema: parseInt(resumo.internetProblema) || 0,
      pessoasFisicas: parseInt(resumo.pessoasFisicas ?? resumo.pessoas_fisicas) || 0,
      pessoasJuridicas: parseInt(resumo.pessoasJuridicas ?? resumo.pessoas_juridicas) || 0,
      contratosBloqueioManual,
      valorBloqueioManual,
      titulosEmitidos,
      contratosEmitidos,
      valorEmitido,
      valorAteVencimento,
      descontoTotal,
      titulosRecebidos,
      contratosRecebidos,
      valorRecebido,
      titulosEmitidosPf,
      contratosEmitidosPf,
      valorEmitidoPf,
      titulosRecebidosPf,
      contratosRecebidosPf,
      valorRecebidoPf,
      titulosEmitidosPj,
      contratosEmitidosPj,
      valorEmitidoPj,
      titulosRecebidosPj,
      contratosRecebidosPj,
      valorRecebidoPj,
      cidades,
      planos: Array.isArray(resumo.planos) ? resumo.planos.map((plano) => this.adaptarPlano(plano)) : [],
      data_fim: resumo.data_fim || getTodayLocalDate()
    };
  }
  /**
   * Buscar dados consolidados de contratos para múltiplas empresas
   */
  async buscarDadosConsolidados(companyIds, filtros = {}) {
    try {
      const dateRange = getDefaultDateRange();
      const dataInicio = filtros.data_inicio || dateRange.data_inicio;
      const dataFim = filtros.data_fim || dateRange.data_fim;
      
      const dadosConsolidados = {
        contratos: [],
        resumo: {
          totalContratos: 0,
          valorTotal: 0,
          faturamentoCpf: 0,
          faturamentoCnpj: 0,
          faturamentoPessoaFisica: 0,
          faturamentoPessoaJuridica: 0,
          ativos: 0,
          suspensos: 0,
          internetOk: 0,
          internetProblema: 0,
          pessoasFisicas: 0,
          pessoasJuridicas: 0,
          contratosBloqueioManual: 0,
          valorBloqueioManual: 0,
          titulosEmitidos: 0,
          contratosEmitidos: 0,
          valorEmitido: 0,
          valorAteVencimento: 0,
          descontoTotal: 0,
          titulosRecebidos: 0,
          contratosRecebidos: 0,
          valorRecebido: 0,
          titulosEmitidosPf: 0,
          contratosEmitidosPf: 0,
          valorEmitidoPf: 0,
          titulosRecebidosPf: 0,
          contratosRecebidosPf: 0,
          valorRecebidoPf: 0,
          titulosEmitidosPj: 0,
          contratosEmitidosPj: 0,
          valorEmitidoPj: 0,
          titulosRecebidosPj: 0,
          contratosRecebidosPj: 0,
          valorRecebidoPj: 0,
          cidades: [],
          planos: [],
          data_fim: getTodayLocalDate()
        },
        cidades: [],
        total: 0,
        limite: filtros.limite || 25,
        offset: filtros.offset || 0
      };

      // Buscar dados de cada empresa
      const promises = companyIds.map(companyId => 
        this.buscarDadosEmpresa(companyId, { ...filtros, data_inicio: dataInicio, data_fim: dataFim })
      );

      const resultados = await Promise.all(promises);
      
      // Consolidar dados

      resultados.forEach((resultado, index) => {
        if (resultado && resultado.success) {

          this.consolidarContratos(dadosConsolidados.contratos, resultado.contratos, resultado.companyName);
          this.consolidarResumo(dadosConsolidados.resumo, resultado.resumo, resultado.companyName);
          this.consolidarCidades(dadosConsolidados.cidades, resultado.cidades || []);
        } else {
          console.warn(`⚠️ Empresa ${companyIds[index]} falhou na consolidação:`, resultado);
        }
      });


      // Ordenar contratos por data de ativação (mais recentes primeiro)
      dadosConsolidados.contratos.sort((a, b) => {
        const dataA = new Date(a.data_ativacao);
        const dataB = new Date(b.data_ativacao);
        return dataB - dataA;
      });

      // O resumo já foi consolidado das empresas individuais
      dadosConsolidados.resumo.cidades = dadosConsolidados.resumo.cidades || dadosConsolidados.cidades;

      // Aplicar paginação
      const totalContratos = dadosConsolidados.contratos.length;
      const inicio = dadosConsolidados.offset;
      const fim = inicio + dadosConsolidados.limite;
      dadosConsolidados.contratos = dadosConsolidados.contratos.slice(inicio, fim);
      dadosConsolidados.total = totalContratos; // Total antes da paginação
      
      return {
        success: true,
        contratos: dadosConsolidados.contratos,
        resumo: dadosConsolidados.resumo,
        cidades: dadosConsolidados.cidades,
        total: dadosConsolidados.total,
        limite: dadosConsolidados.limite,
        offset: dadosConsolidados.offset
      };

    } catch (error) {
      console.error('❌ Erro ao consolidar contratos:', error);
      throw error;
    }
  }

  /**
   * Buscar dados de uma empresa específica
   */
  async buscarDadosEmpresa(companyId, filtros) {
    try {
      const dateRange = getDefaultDateRange();
      const params = {
        empresa: companyId,
        status: filtros.status || 'A',
        cidade: filtros.cidade || 'todas',
        tipo_pessoa: filtros.tipo_pessoa || 'todos',
        data_inicio: filtros.data_inicio || dateRange.data_inicio,
        data_fim: filtros.data_fim || dateRange.data_fim,
        limite: 1000, // Buscar mais dados para consolidação
        offset: 0
      };


      // Buscar contratos e resumo em paralelo
      const [contratosResponse, resumoResponse] = await Promise.all([
        api.post('/n8n/contratos', params),
        this.buscarResumoEmpresa(companyId, { ...filtros, data_inicio: params.data_inicio, data_fim: params.data_fim })
      ]);
      
      
      // Verificar se a resposta é válida (pode ter diferentes estruturas)
      if (contratosResponse.data && (contratosResponse.data.success || contratosResponse.data.contratos)) {
        return {
          success: true,
          companyName: companyId,
          contratos: contratosResponse.data.contratos || [],
          resumo: resumoResponse.resumo || {},
          cidades: resumoResponse.resumo?.cidades || contratosResponse.data.cidades || []
        };
      } else {
        console.error(`❌ Resposta inválida para ${companyId}:`, contratosResponse.data);
        throw new Error(`Erro na resposta da API para ${companyId}: ${contratosResponse.data?.message || 'Resposta inválida'}`);
      }
    } catch (error) {
      console.error(`❌ Erro ao buscar dados da empresa ${companyId}:`, error);
      return {
        success: false,
        companyName: companyId,
        contratos: [],
        resumo: {},
        cidades: []
      };
    }
  }

  /**
   * Buscar resumo de uma empresa específica
   */
  async buscarResumoEmpresa(companyId, filtros) {
    try {
      const dateRange = getDefaultDateRange();
      const params = {
        empresa: companyId,
        status: filtros.status || 'A',
        cidade: filtros.cidade || 'todas',
        tipo_pessoa: filtros.tipo_pessoa || 'todos',
        data_inicio: filtros.data_inicio || dateRange.data_inicio,
        data_fim: filtros.data_fim || dateRange.data_fim
      };


      const response = await api.post('/n8n/contratos/resumo', params);
      
      if (response.data) {
        return {
          success: true,
          resumo: this.adaptarResumo(response.data)
        };
      } else {
        throw new Error('Resposta inválida da API');
      }
    } catch (error) {
      console.error(`❌ Erro ao buscar resumo da empresa ${companyId}:`, error);
      return {
        success: false,
        resumo: {}
      };
    }
  }

  /**
   * Consolidar lista de contratos
   */
  consolidarContratos(consolidado, contratos, empresa) {
    
    contratos.forEach(contrato => {
      // Adaptar contrato usando a mesma lógica do serviço normal
      const contratoAdaptado = this.adaptarContrato(contrato);
      
      // Adicionar informação da empresa ao contrato
      const contratoComEmpresa = {
        ...contratoAdaptado,
        empresa_origem: empresa,
        id_consolidado: `${empresa}_${contratoAdaptado.id}`
      };
      
      consolidado.push(contratoComEmpresa);
    });
    
  }

  /**
   * Consolidar resumo de contratos
   */
  consolidarResumo(consolidado, resumo, empresa) {
    
    // Adaptar resumo usando a mesma lógica do serviço normal
    const resumoAdaptado = this.adaptarResumo(resumo);
    
    consolidado.totalContratos += resumoAdaptado.totalContratos;
    consolidado.valorTotal += resumoAdaptado.valorTotal;
    consolidado.faturamentoCpf += resumoAdaptado.faturamentoCpf;
    consolidado.faturamentoCnpj += resumoAdaptado.faturamentoCnpj;
    consolidado.faturamentoPessoaFisica += resumoAdaptado.faturamentoPessoaFisica ?? resumoAdaptado.faturamentoCpf;
    consolidado.faturamentoPessoaJuridica += resumoAdaptado.faturamentoPessoaJuridica ?? resumoAdaptado.faturamentoCnpj;
    consolidado.ativos += resumoAdaptado.ativos;
    consolidado.suspensos += resumoAdaptado.suspensos;
    consolidado.internetOk += resumoAdaptado.internetOk;
    consolidado.internetProblema += resumoAdaptado.internetProblema;
    consolidado.pessoasFisicas += resumoAdaptado.pessoasFisicas;
    consolidado.pessoasJuridicas += resumoAdaptado.pessoasJuridicas;
    consolidado.contratosBloqueioManual += resumoAdaptado.contratosBloqueioManual || 0;
    consolidado.valorBloqueioManual += resumoAdaptado.valorBloqueioManual || 0;
    consolidado.titulosEmitidos += resumoAdaptado.titulosEmitidos || 0;
    consolidado.contratosEmitidos += resumoAdaptado.contratosEmitidos || 0;
    consolidado.valorEmitido += resumoAdaptado.valorEmitido || 0;
    consolidado.valorAteVencimento += resumoAdaptado.valorAteVencimento || 0;
    consolidado.descontoTotal += resumoAdaptado.descontoTotal || 0;
    consolidado.titulosRecebidos += resumoAdaptado.titulosRecebidos || 0;
    consolidado.contratosRecebidos += resumoAdaptado.contratosRecebidos || 0;
    consolidado.valorRecebido += resumoAdaptado.valorRecebido || 0;
    consolidado.titulosEmitidosPf += resumoAdaptado.titulosEmitidosPf || 0;
    consolidado.contratosEmitidosPf += resumoAdaptado.contratosEmitidosPf || 0;
    consolidado.valorEmitidoPf += resumoAdaptado.valorEmitidoPf || 0;
    consolidado.titulosRecebidosPf += resumoAdaptado.titulosRecebidosPf || 0;
    consolidado.contratosRecebidosPf += resumoAdaptado.contratosRecebidosPf || 0;
    consolidado.valorRecebidoPf += resumoAdaptado.valorRecebidoPf || 0;
    consolidado.titulosEmitidosPj += resumoAdaptado.titulosEmitidosPj || 0;
    consolidado.contratosEmitidosPj += resumoAdaptado.contratosEmitidosPj || 0;
    consolidado.valorEmitidoPj += resumoAdaptado.valorEmitidoPj || 0;
    consolidado.titulosRecebidosPj += resumoAdaptado.titulosRecebidosPj || 0;
    consolidado.contratosRecebidosPj += resumoAdaptado.contratosRecebidosPj || 0;
    consolidado.valorRecebidoPj += resumoAdaptado.valorRecebidoPj || 0;
    if (!Array.isArray(consolidado.planos)) {
      consolidado.planos = [];
    }
    this.consolidarPlanos(consolidado.planos, resumoAdaptado.planos || [], empresa);
    if (!Array.isArray(consolidado.cidades)) {
      consolidado.cidades = [];
    }
    this.consolidarCidades(consolidado.cidades, resumoAdaptado.cidades || [], empresa);
    
  }

  /**
   * Calcula o resumo dos contratos consolidados (fallback local)
   */
  calcularResumoConsolidado(contratos) {
    const resumo = {
      totalContratos: contratos.length,
      valorTotal: 0,
      faturamentoCpf: 0,
      faturamentoCnpj: 0,
      faturamentoPessoaFisica: 0,
      faturamentoPessoaJuridica: 0,
      ativos: 0,
      suspensos: 0,
      internetOk: 0,
      internetProblema: 0,
      pessoasFisicas: 0,
      pessoasJuridicas: 0,
      contratosBloqueioManual: 0,
      valorBloqueioManual: 0,
      titulosEmitidos: 0,
      contratosEmitidos: 0,
      valorEmitido: 0,
      valorAteVencimento: 0,
      descontoTotal: 0,
      titulosRecebidos: 0,
      contratosRecebidos: 0,
      valorRecebido: 0,
      titulosEmitidosPf: 0,
      contratosEmitidosPf: 0,
      valorEmitidoPf: 0,
      titulosRecebidosPf: 0,
      contratosRecebidosPf: 0,
      valorRecebidoPf: 0,
      titulosEmitidosPj: 0,
      contratosEmitidosPj: 0,
      valorEmitidoPj: 0,
      titulosRecebidosPj: 0,
      contratosRecebidosPj: 0,
      valorRecebidoPj: 0,
      planos: [],
      data_fim: getTodayLocalDate()
    };

    contratos.forEach(contrato => {
      // Soma o valor total dos contratos
      const valorContrato = contrato.valor_contrato || 0;
      resumo.valorTotal += valorContrato;

      // Status do contrato: A = Ativo, D = Desativado, CM = Bloqueio Manual, CA = Bloqueio Automático, FA = Financeiro em atraso, AA = Aguardando Assinatura
      if (contrato.status_contrato === 'A') {
        resumo.ativos++;
      } else if (['D', 'CM', 'CA', 'FA'].includes(contrato.status_contrato)) {
        // Desativado, Bloqueio Manual, Bloqueio Automático, Financeiro em atraso = Suspensos
        resumo.suspensos++;
      } else if (contrato.status_contrato === 'AA') {
        // Aguardando Assinatura não conta para ativos nem suspensos
      } else {
        // Para valores antigos ou desconhecidos, considerar como suspenso
        resumo.suspensos++;
      }

      // Status da internet: S = com conexão, N = sem conexão, SS = sem status
      if (contrato.status_internet === 'S') {
        resumo.internetOk++;
      } else if (contrato.status_internet === 'N') {
        resumo.internetProblema++;
      } else if (contrato.status_internet === 'SS') {
        // Sem status não conta para nenhum dos dois
      } else {
        // Para valores antigos ou desconhecidos, considerar como problema
        resumo.internetProblema++;
      }

      // Tipo de pessoa (usando valores mapeados)
      if (contrato.tipo_pessoa === 'Física') {
        resumo.pessoasFisicas++;
        resumo.faturamentoCpf += valorContrato;
        resumo.faturamentoPessoaFisica += valorContrato;
      } else if (contrato.tipo_pessoa === 'Jurídica') {
        resumo.pessoasJuridicas++;
        resumo.faturamentoCnpj += valorContrato;
        resumo.faturamentoPessoaJuridica += valorContrato;
      } else if (contrato.tipo_pessoa === 'Estrangeiro') {
        if (!resumo.pessoasEstrangeiras) {
          resumo.pessoasEstrangeiras = 0;
        }
        resumo.pessoasEstrangeiras++;
      }
    });

    return resumo;
  }

  /**
   * Consolidar lista de cidades
   */
  consolidarCidades(consolidado, cidades, empresa = null) {
    if (!Array.isArray(cidades)) {
      return;
    }

    cidades.forEach((cidadeAtual) => {
      if (!cidadeAtual) {
        return;
      }

      if (typeof cidadeAtual === 'string') {
        if (!consolidado.includes(cidadeAtual)) {
          consolidado.push(cidadeAtual);
        }
        return;
      }

      const cidade = this.adaptarCidade(cidadeAtual);
      const chave = this.normalizarChaveCidade(cidade);
      const existente = consolidado.find((item) => this.normalizarChaveCidade(item) === chave);

      if (existente) {
        existente.totalContratos += cidade.totalContratos;
        existente.valorTotal += cidade.valorTotal;
        existente.ativos += cidade.ativos;
        existente.suspensos += cidade.suspensos;
        existente.pessoasFisicas += cidade.pessoasFisicas;
        existente.pessoasJuridicas += cidade.pessoasJuridicas;
        existente.faturamentoPessoaFisica += cidade.faturamentoPessoaFisica;
        existente.faturamentoPessoaJuridica += cidade.faturamentoPessoaJuridica;
        existente.contratosBloqueioManual += cidade.contratosBloqueioManual;
        existente.valorBloqueioManual += cidade.valorBloqueioManual;
        existente.titulosEmitidos += cidade.titulosEmitidos;
        existente.contratosEmitidos += cidade.contratosEmitidos;
        existente.valorEmitido += cidade.valorEmitido;
        existente.valorAteVencimento += cidade.valorAteVencimento;
        existente.descontoTotal += cidade.descontoTotal;
        existente.titulosRecebidos += cidade.titulosRecebidos;
        existente.contratosRecebidos += cidade.contratosRecebidos;
        existente.valorRecebido += cidade.valorRecebido;
        existente.titulosEmitidosPf += cidade.titulosEmitidosPf;
        existente.contratosEmitidosPf += cidade.contratosEmitidosPf;
        existente.valorEmitidoPf += cidade.valorEmitidoPf;
        existente.titulosRecebidosPf += cidade.titulosRecebidosPf;
        existente.contratosRecebidosPf += cidade.contratosRecebidosPf;
        existente.valorRecebidoPf += cidade.valorRecebidoPf;
        existente.titulosEmitidosPj += cidade.titulosEmitidosPj;
        existente.contratosEmitidosPj += cidade.contratosEmitidosPj;
        existente.valorEmitidoPj += cidade.valorEmitidoPj;
        existente.titulosRecebidosPj += cidade.titulosRecebidosPj;
        existente.contratosRecebidosPj += cidade.contratosRecebidosPj;
        existente.valorRecebidoPj += cidade.valorRecebidoPj;

        if (!Array.isArray(existente.planos)) {
          existente.planos = [];
        }

        this.consolidarPlanos(existente.planos, cidade.planos || [], empresa);

        if (empresa) {
          if (!Array.isArray(existente.empresas)) {
            existente.empresas = [];
          }
          if (!existente.empresas.includes(empresa)) {
            existente.empresas.push(empresa);
          }
        }
      } else {
        consolidado.push({
          ...cidade,
          planos: Array.isArray(cidade.planos) ? cidade.planos.map((plano) => this.adaptarPlano(plano)) : [],
          empresas: empresa ? [empresa] : []
        });
      }
    });

    if (consolidado.length && typeof consolidado[0] === 'string') {
      consolidado.sort((a, b) => a.localeCompare(b, 'pt-BR'));
      return;
    }

    consolidado.sort((a, b) => String(a.cidadeNome || '').localeCompare(String(b.cidadeNome || ''), 'pt-BR'));
  }

  /**
   * Buscar cidades consolidadas
   */
  async buscarCidadesConsolidadas(companyIds) {
    try {
      const promises = companyIds.map(companyId => 
        this.buscarCidadesEmpresa(companyId)
      );

      const resultados = await Promise.all(promises);
      
      const cidadesConsolidadas = [];
      resultados.forEach(resultado => {
        if (resultado && resultado.success) {
          this.consolidarCidades(cidadesConsolidadas, resultado.cidades);
        }
      });

      return {
        success: true,
        cidades: cidadesConsolidadas
      };
    } catch (error) {
      console.error('❌ Erro ao buscar cidades consolidadas:', error);
      throw error;
    }
  }

  /**
   * Buscar cidades de uma empresa específica
   */
  async buscarCidadesEmpresa(companyId) {
    try {
      const response = await api.post('/n8n/contratos/cidades', { empresa: companyId });
      
      if (response.data && response.data.success) {
        return {
          success: true,
          cidades: response.data.cidades || []
        };
      } else {
        throw new Error(`Erro na resposta da API para ${companyId}`);
      }
    } catch (error) {
      console.error(`❌ Erro ao buscar cidades da empresa ${companyId}:`, error);
      return {
        success: false,
        cidades: []
      };
    }
  }
}

const contratosConsolidadoService = new ContratosConsolidadoService();
export default contratosConsolidadoService;
